var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyplan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1984078956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 101",
    d: "M6.42885 15.75L4.10742 8.32143L8.28599 10.1786L12.0003 6L15.7146 10.1786L19.8931 8.32143L18.036 15.75M6.42885 15.75H18.036M6.42885 15.75V19H18.036V15.75",
    stroke: "url(#paint0_linear_4969_26962)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4969_26962",
    x1: -1,
    y1: 3.5,
    x2: 24.6255,
    y2: 2.43608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#102279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyplan);
export default __webpack_public_path__ + "static/media/myplan.a6c504fe9d5d22b5f3605862a04e8f52.svg";
export { ForwardRef as ReactComponent };